var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#864FFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9246 14.4585C14.867 13.4658 15.2 13.1873 15.6016 13.0578C15.8795 12.985 16.1709 12.9809 16.4508 13.046C16.8191 13.1531 16.9166 13.2345 18.1245 14.4381C19.1857 15.495 19.2917 15.6096 19.3934 15.8163C19.588 16.1791 19.6184 16.6076 19.477 16.9942C19.3699 17.2887 19.2178 17.4836 18.5742 18.1293L18.1545 18.5502C18.0443 18.6623 18.0183 18.8323 18.0902 18.9722C19.0229 20.5632 20.3461 21.8901 21.9346 22.8272C22.1175 22.9251 22.3427 22.8935 22.4914 22.7491L22.8951 22.3518C23.1446 22.0959 23.4089 21.855 23.6865 21.63C24.1225 21.3623 24.6658 21.3384 25.1236 21.5668C25.3474 21.6739 25.4213 21.7403 26.5157 22.8326C27.6444 23.9581 27.6765 23.9934 27.8007 24.2515C28.0345 24.6786 28.032 25.1961 27.7943 25.6211C27.6733 25.861 27.5994 25.9477 26.9644 26.5966C26.581 26.9886 26.2201 27.3462 26.1623 27.3987C25.6384 27.8324 24.9664 28.0452 24.2883 27.992C23.0478 27.8789 21.8471 27.4954 20.7705 26.8686C18.386 25.6051 16.3559 23.7643 14.8659 21.5144C14.5414 21.0434 14.2528 20.5487 14.0028 20.0344C13.332 18.8847 12.9856 17.5746 13.0005 16.2436C13.0517 15.5473 13.3856 14.9022 13.9246 14.4585Z",
    stroke: "#864FFD",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.3b989188b8770c1b7f1dd49274da6c69.svg";
export { ForwardRef as ReactComponent };